/**
 * Dep-free confetti burst. Spawns 90 small tinted divs from a center point,
 * gives each a random velocity + rotation via CSS keyframes, and cleans up
 * ~2.5s later. Call `fireConfetti({ x, y })` in any success handler.
 */
const COLORS = ["#6366f1", "#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#a855f7", "#22d3ee"];

let styleInjected = false;
function ensureStyles() {
  if (styleInjected) return;
  styleInjected = true;
  const s = document.createElement("style");
  s.setAttribute("data-confetti", "1");
  s.textContent = `
    @keyframes tl-confetti-fall {
      0%   { opacity: 1; transform: translate3d(0,0,0) rotate(0deg) scale(1); }
      100% { opacity: 0;
             transform: translate3d(var(--dx), var(--dy), 0)
                        rotate(var(--dr)) scale(var(--ds)); }
    }
    .tl-confetti-piece {
      position: fixed; z-index: 9999; top: 0; left: 0;
      width: 8px; height: 12px; border-radius: 2px;
      pointer-events: none; will-change: transform, opacity;
      animation: tl-confetti-fall 1.8s cubic-bezier(.2,.6,.2,1) forwards;
    }
  `;
  document.head.appendChild(s);
}

export default function fireConfetti({ x, y, count = 90 } = {}) {
  ensureStyles();
  const cx = x ?? window.innerWidth / 2;
  const cy = y ?? window.innerHeight * 0.35;
  const frag = document.createDocumentFragment();
  for (let i = 0; i < count; i++) {
    const el = document.createElement("span");
    el.className = "tl-confetti-piece";
    el.style.left = `${cx}px`;
    el.style.top = `${cy}px`;
    el.style.background = COLORS[i % COLORS.length];
    const angle = Math.random() * Math.PI * 2;
    const distance = 220 + Math.random() * 240;
    const dx = Math.cos(angle) * distance;
    const dy = Math.sin(angle) * distance + 200; // extra downward gravity feel
    el.style.setProperty("--dx", `${dx}px`);
    el.style.setProperty("--dy", `${dy}px`);
    el.style.setProperty("--dr", `${(Math.random() * 720 - 360)}deg`);
    el.style.setProperty("--ds", `${0.6 + Math.random() * 0.8}`);
    el.style.animationDelay = `${Math.random() * 120}ms`;
    frag.appendChild(el);
    setTimeout(() => el.remove(), 2200);
  }
  document.body.appendChild(frag);
}
